'use strict';

var _ = require('lodash');

var ret = {};
ret.methods = ['ACH', 'SixPlus Credit Card', 'Check', 'Client Paid Venue Directly', 'Invoice'];
ret.sixplusPayoutMethods = _.without(ret.methods, 'Client Paid Venue Directly');

ret.status = ['READY TO BE CLOSED', 'ON HOLD'];

module.exports = ret;